module.exports = __webpack_public_path__ + "img/77384.393dd036.svg";